// extracted by mini-css-extract-plugin
export default {"container":"Reviews_container__EhoSX","box":"Reviews_box__fliqX","header":"Reviews_header__SNpwl","text":"Reviews_text__P2nvC"};